import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from './auth.service';
import { EMPTY, catchError, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'oc-reset-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormlyBootstrapModule, FormlyModule, RouterModule],
  template: `
    <div class="conainer">
      <div class="row justify-content-md-center">
        <div class="col col-4">
          <div class="p-3">
            <h1>Reset Password</h1>
            <form [formGroup]="form" (ngSubmit)="onSubmit(model)">
              <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
              <button type="submit" class="btn btn-primary w-100 mt-3 mb-4">
                <span *ngIf="loggingIn" class="spinner-border spinner-border-sm"></span>
                <span *ngIf="!loggingIn">Submit</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: `
    
  `,
})
export class ResetPasswordComponent {
  private auth = inject(AuthService);
  private router = inject(Router);
  private toastr = inject(ToastrService);

  loggingIn = false;
  form = new FormGroup({});
  model = { email: '', verificationCode: '', newPassword: '' };

  options: FormlyFormOptions = {
    formState: {
      submitted: false,
    },
  };

  fields: FormlyFieldConfig[] = [
    {
      key: 'email',
      type: 'input',
      props: {
        label: 'Email',
        required: true,
        type: 'email',
      },
      validators: {
        validation: ['email'],
      },
    },
    {
      key: 'verificationCode',
      type: 'input',
      props: {
        label: 'Verification Code',
        required: true,
      },
    },
    {
      key: 'newPassword',
      type: 'input',
      props: {
        label: 'New Password',
        required: true,
        type: 'password',
      },
    },
  ];

  onSubmit(model: any) {
    this.options.formState.submitted = true;

    if (this.loggingIn) {
      return;
    }

    if (!this.form.valid) {
      this.toastr.error('Please review your login details and try again');
      return;
    }

    this.loggingIn = true;

    this.auth
      .resetPassword(model.email, model.verificationCode, model.newPassword)
      .pipe(
        catchError((err) => {
          this.toastr.error(err.message);
          this.loggingIn = false;
          return EMPTY;
        }),
        tap(() => {
          this.router.navigate(['/']);
        }),
      )
      .subscribe();
  }
}
